import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
const CampaignDisplays = {
    name: 'campaignDisplays',
    state: {
        data: [],
        loading: false,
        error: '',
        totalCount: 0,
        currentReq: null,
        tableHeader: [
            'Campaign Name',
            'Start Date',
            'End Date',
            'Manager Email',
            'Budget',
            'Status',
        ],
        rpp: 10,
    },
    reducers: {
        getRequested(state) {
            return {
                ...state,
                loading: true,
                error: '',
                data: [],
                totalCount: 0,
                currentReq: null,
            };
        },

        getReceived(state, payload) {
            return {
                ...state,
                data: payload.data,
                loading: false,
                error: '',
                totalCount: payload.totalCount,
                currentReq: payload.currentReq,
            };
        },

        getRequestFailed(state, payload) {
            return {
                ...state,
                error: payload,
            };
        },
    },
    effects: (dispatch) => ({
        async getAll({ page, size, search, sorted_by, sort }) {
            try {
                this.getRequested();
                const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
                const adv_id = userInfo.adv_id || userInfo.id || userInfo.org_id;
                if (!adv_id) throw new Error('Missing advertiser id');
                let url = `savvy/campaigns/${adv_id}?page=${page}&size=${size}`;
                if (search) {
                    url = url + `&search=${search}`;
                }
                if (sorted_by) {
                    url = url + `&sorted_by=${sorted_by}`;
                }
                if (sort) {
                    url = url + `&sort=${sort}`;
                }
                const response = await http.get(url);

                this.getReceived({
                    data: response.data.data.rows,
                    totalCount: response.data.data.count,
                });
            } catch (err) {
                this.getRequestFailed(err.message);
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
        async getFullDetails(request_id, state) {
            try {
                this.getRequested();

                const user = JSON.parse(localStorage.getItem('userInfo'));
                let url = `savvy/approval-flow/details/${request_id}?user_id=${user?.id}&org=${user?.org_id}`;
                const response = await http.get(url);

                this.getReceived({
                    currentReq: response.data?.data,
                });
            } catch (err) {
                this.getRequestFailed({ reqError: err?.message });
                dispatch({
                    type: 'helper/show',
                    payload: {
                        type: 'error',
                        message: responseMessageHandler.show(err.message),
                        show: true,
                    },
                });
            }
        },
    }),
};

export default CampaignDisplays;
